module.exports = __webpack_public_path__ + "img/Stortingsmelding_Normgrunnlag_og_normeringsprinsipp.5540799c.jpg";